import React, { useState, useEffect } from "react";
import "./css/textEditor.css";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coldarkDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import {
  Editor,
  EditorState,
  RichUtils,
  convertToRaw,
  convertFromRaw,
  Modifier,
  getDefaultKeyBinding,
  DefaultDraftBlockRenderMap,
} from "draft-js";
import "draft-js/dist/Draft.css";
import Immutable from "immutable";

var INLINE_STYLES = [
  { label: "Bold", style: "BOLD" },
  { label: "Italic", style: "ITALIC" },
  { label: "Underline", style: "UNDERLINE" },
  { label: "Monospace", style: "CODE" },
];

var BLOCK_TYPES = [
  // { label: 'H1', style: 'header-one' },
  // { label: 'H2', style: 'header-two' },
  { label: "Header", style: "header-two" },
  { label: "Sub-Header", style: "header-three" },

  // { label: 'H3', style: 'header-three' },
  // { label: 'H4', style: 'header-four' },
  // { label: 'H5', style: 'header-five' },
  { label: "Content", style: "header-five" },
  // { label: 'H6', style: 'header-six' },
  { label: "Blockquote", style: "blockquote" },
  { label: "UL", style: "unordered-list-item" },
  { label: "OL", style: "ordered-list-item" },
  { label: "Code Block", style: "code-block" },
  // { label: 'Atomic', style: 'atomic' },
  // { label: 'DEL', style: 'delete-all' },
];

// Custom overrides for "code" style.
const styleMap = {
  "code-block": {
    backgroundColor: "rgba(0, 200, 0, 1)",
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 26,
    padding: 2,
  },
};
const blockRenderMap = Immutable.Map({
  unstyled: {
    element: "div",
  },
});
const extendedBlockRenderMap = DefaultDraftBlockRenderMap.merge(blockRenderMap);

function getBlockStyle(block) {
  switch (block.getType()) {
    case "blockquote":
      return "RichEditor-blockquote";
    case "header-six":
      return "h6style";
    case "code-block":
      return "codestyle";
    default:
      return null;
  }
}

const BlockStyleControls = (props) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

const InlineStyleControls = (props) => {
  const currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = "RichEditor-styleButton";
    if (this.props.active) {
      className += " RichEditor-activeButton";
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

class MyEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      editorStateFreez: EditorState.createEmpty(),
      last_update: "",
      stateChange: false,
    };
    this.focus = () => this.refs.editor.focus();

    this.mapKeyToEditorCommand = this._mapKeyToEditorCommand.bind(this);
    this.toggleBlockType = this._toggleBlockType.bind(this);
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this);
    this.onChange = (editorState) => {
      this.setState({ editorState });
      if (
        editorState.getCurrentContent() !==
        this.state.editorStateFreez.getCurrentContent()
      ) {
        this.setState({ stateChange: true });
      } else {
        this.setState({ stateChange: false });
      }
    };

    this.handleKeyCommand = this.handleKeyCommand.bind(this);
    this.update_atInterval = this.update_atInterval.bind(this);
  }

  componentDidMount() {
    // Load editor data (raw js object) from local storage
    console.log("TextEditor >>");
    var dummy = this.props.data.d.source;
    if (dummy[0] === "{") {
      //the json is ok
      console.log("Json Ok");
      const rawEditorData = JSON.parse(dummy);
      if (rawEditorData !== null) {
        const contentState = convertFromRaw(rawEditorData);
        this.setState({
          editorState: EditorState.createWithContent(contentState),
          editorStateFreez: EditorState.createWithContent(contentState),
        });
      }
    } else {
      //the json is not ok
      let contentState = this.state.editorState.getCurrentContent();
      let targetRange = this.state.editorState.getSelection();
      let newContentState = Modifier.insertText(
        contentState,
        targetRange,
        dummy
      );
      // const new_contentState = convertFromRaw(newContentState);
      this.setState({
        editorState: EditorState.createWithContent(newContentState),
        editorStateFreez: EditorState.createWithContent(newContentState),
      });
      console.log("Dummy", newContentState);
    }

    console.log("TextEditor <<");
  }

  handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command);

    if (newState) {
      this.onChange(newState);
      return "handled";
    }

    return "not-handled";
  }
  toggleBlockType = (blockType) => {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType));
  };

  _onBoldClick() {
    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, "BOLD"));
  }
  _onToolBarClick(target) {
    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, target));
  }

  // onSaveStateChange = () => {
  //   console.log("nu");
  //   if(this.state.editorState !== this.state.editorStateFreez){
  //     this.setState({stateChange : true});
  //   }
  //   else {
  //     this.setState({stateChange : false});
  //   }
  // }

  update_atInterval = () => {
    var index = this.props.data.index;
    const raw = convertToRaw(this.state.editorState.getCurrentContent());
    const raw_data = JSON.stringify(raw);
    console.log("useefeect or butoon clicked", index, raw_data);
    this.props.data.updatecell(
      index,
      raw_data,
      "code_lan",
      this.props.data.d.cell_layout.code_lan,
      this.state.last_update
    );
    this.setState({ last_update: Date.now() });
    this.setState({ editorStateFreez: this.state.editorState });
    this.setState({ stateChange: false });
  };

  _mapKeyToEditorCommand(e) {
    if (e.keyCode === 9 /* TAB */) {
      const newEditorState = RichUtils.onTab(
        e,
        this.state.editorState,
        4 /* maxDepth */
      );
      if (newEditorState !== this.state.editorState) {
        this.onChange(newEditorState);
      }
      return;
    }
    return getDefaultKeyBinding(e);
  }

  _toggleBlockType(blockType) {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType));
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle)
    );
  }

  render() {
    console.log("editor State ", this.state.editorState);

    const { editorState } = this.state;
    // this.onSaveStateChange.bind();

    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = "RichEditor-editor";
    var contentState = editorState.getCurrentContent();
    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== "unstyled") {
        className += " RichEditor-hidePlaceholder";
      }
    }

    return (
      <div className="text-edit-container">
        <div>
          <div className="Toolbar-TextEditor">
            {/* <button onClick={this._onToolBarClick.bind(this,"ITALIC")}>I</button>
        <button onClick={this._onToolBarClick.bind(this,"H3")}>h1</button>
        <button onClick={this._onToolBarClick.bind(this,"BOLD")}>Bold</button> */}

            {/* <Editor
            editorState={this.state.editorState}
            handleKeyCommand={this.handleKeyCommand}
            onChange={this.onChange}
          /> */}
            <BlockStyleControls
              editorState={editorState}
              onToggle={this.toggleBlockType}
            />
            <InlineStyleControls
              editorState={editorState}
              onToggle={this.toggleInlineStyle}
            />
            <div className={className} onClick={this.focus}>
              <Editor
                blockStyleFn={getBlockStyle}
                customStyleMap={styleMap}
                blockRenderMap={extendedBlockRenderMap}
                editorState={editorState}
                handleKeyCommand={this.handleKeyCommand}
                keyBindingFn={this.mapKeyToEditorCommand}
                onChange={this.onChange}
                placeholder="Tell a story..."
                ref="editor"
                spellCheck={true}
              />
            </div>
            <br />
            <div className="text-edit-bottom">
              <span onClick={this.update_atInterval}>
                <i className="material-icons">save</i>
              </span>
              {this.state.stateChange ? (
                <h6> --- changes detected..!</h6>
              ) : (
                <></>
              )}
            </div>
            {/* <Editor editorState={this.state.editorStateFreez} readOnly /> */}
          </div>
        </div>
      </div>
    );
  }
}
export default MyEditor;
